import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";

type WebTimeOffTileProps = {
    onNavigate?: () => void;
};

const WebTimeOffTile: React.FC<WebTimeOffTileProps> = ({ onNavigate }) => {
    const navigate = useNavigate();
    const { setSourcePath } = useNavigationHistory();

    const handleNavigate = () => {
        if (onNavigate) {
            onNavigate();
            return;
        }

        setSourcePath("/web-dashboard");
        navigate("/m-timeoff", { state: { from: "/web-dashboard" } });
    };

    return (
        <div className="p-6 h-full cursor-pointer" onClick={handleNavigate}>
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg text-blue-600 leading-tight hover:text-blue-600 transition-colors">
                    Planned Time Off
                </h2>
                <Calendar className="w-5 h-5 flex-shrink-0 text-gray-400" />
            </div>

            <div className="flex-1 flex flex-col items-center justify-center">
                <div className="text-center">
                    <Calendar className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                    <p className="text-sm text-gray-500">View your time off requests</p>
                </div>
            </div>
        </div>
    );
};

export default WebTimeOffTile; 
